export default {
  companyList: (state) => state.companyList,
  newIssuesOnly: (state) => state.newIssuesOnly,
  companyListFetching: (state) => state.companyListFetching,
  companyMap: (state) => state.companyMap,
  currentCompany: (state) => state.currentCompany,
  companyWatcher: (state) => state.companyWatcher,
  gicsList: (state) => state.gicsList,
  cashSourceList: (state) => state.cashSourceList,
  terminalNavigationVisible: (state) => state.terminalNavigationVisible,
  companyUiInfo: (state) => state.companyUiInfo,
  historyList: (state) => state.historyList,
  nextReportingList: (state) => state.nextReportingList,
  lastReportedList: (state) => state.lastReportedList,
  companyListCount: (state) => state.companyListCount,
  searchParam: (state) => state.searchParam,
  companySorting: (state) => state.companySorting,
  memoStructureList: (state) => state.memoStructureList,
  companyListError: (state) => state.companyListError,
  companyListPage: (state) => state.companyListPage,
  searchSuggestions: (state) => state.searchSuggestions,
}
